import { AppShell } from '@layouts/AppShell';
import { Box, CircularProgress } from '@mui/material';
import { HomePage } from '@pages/HomePage';
import { NotFoundPage } from '@pages/NotFoundPage';
import { utilityRegistry } from '@utilities/registry';
import { RequireUtilityAccess } from '@utilities/RequireUtilityAccess';
import { Suspense } from 'react';
import { createBrowserRouter, Navigate } from 'react-router';

const RouteFallback = () => (
  <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
    <CircularProgress size={28} />
  </Box>
);

export const router = createBrowserRouter([
  {
    children: [
      { element: <HomePage />, index: true },
      // Cognito redirects here after the KochID hosted-UI login exchange
      // (see redirectSignIn in configureAmplify.ts). Amplify's Hub listener
      // consumes the auth code before this ever renders, so just bounce home —
      // RequireAuth separately navigates to the pre-login page once the token
      // exchange completes, if there was one (see customOAuthState in RequireAuth.tsx).
      { element: <Navigate replace to="/" />, path: 'auth/callback' },
      ...utilityRegistry.map(utility => ({
        element: (
          <RequireUtilityAccess utilityId={utility.id}>
            <Suspense fallback={<RouteFallback />}>
              <utility.element />
            </Suspense>
          </RequireUtilityAccess>
        ),
        // Strip the leading slash: nested route paths are relative to the parent ("/").
        // The trailing "/*" lets each utility mount its own <Routes> and act like its own app.
        path: `${utility.path.startsWith('/') ? utility.path.slice(1) : utility.path}/*`,
      })),
      { element: <NotFoundPage />, path: '*' },
    ],
    element: <AppShell />,
    path: '/',
  },
]);
